/** Blocks text AND attributes (including bearer-token links) from Sentry Replay. */
export const BUYER_DATA_REPLAY_CLASS = "sentry-block";
export function buyerDataClassName(className: string, buyerData = true): string {
  return buyerData ? `${className} ${BUYER_DATA_REPLAY_CLASS}` : className;
}

function buyerUrl(value: unknown): boolean {
  if (typeof value !== "string") return false;
  try {
    const path = new URL(value, "https://manage.stack.je").pathname;
    return /^\/_builder\/sites\/[^/]+\/shop\/orders(?:\/|$)/.test(path) || /^\/_(?:dl|files)\//.test(path);
  } catch { return false; }
}
function object(value: unknown): Record<string, unknown> | undefined {
  return value !== null && typeof value === "object" ? value as Record<string, unknown> : undefined;
}

/** Replay network entries are independent of DOM blocks and can contain buyer searches or response bodies. */
export function blockBuyerRecordingEvent<T extends { data?: unknown }>(event: T): T | null {
  const data = object(event.data), payload = object(data?.payload), details = object(payload?.data);
  if (buyerUrl(payload?.description) || buyerUrl(details?.url) || buyerUrl(details?.to) || buyerUrl(details?.from)) return null;
  return event;
}
/** The browser SDK also keeps network and click breadcrumbs alongside errors. */
export function blockBuyerBreadcrumb<T extends { data?: Record<string, unknown>; category?: string }>(breadcrumb: T, hint?: { event?: unknown }): T | null {
  if (buyerUrl(breadcrumb.data?.url) || buyerUrl(breadcrumb.data?.to) || buyerUrl(breadcrumb.data?.from)) return null;
  const event = object(hint?.event), target = event?.target;
  const element = typeof Node !== "undefined" && target instanceof Node ? target instanceof Element ? target : target.parentElement : null;
  if (element?.closest(`.${BUYER_DATA_REPLAY_CLASS}`)) return null;
  return breadcrumb;
}
